<template>
  <v-card elevation="0" class="mx-auto" max-width="800">
    <!-- <v-container> -->
    <v-row class="mx-auto">
      <v-col class="text-center" cols="12">
        <v-card max-width="700">
          <v-card-title>{{ $t("traning.video1") }}</v-card-title>
          <v-card-text>
            <youtube class="center-align mx-auto" :video-id="'22TbpI7osd4'"></youtube>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="text-center" cols="12">
        <v-card max-width="700">
          <v-card-title>{{ $t("traning.video2") }}</v-card-title>
          <v-card-text>
            <youtube class="center-align mx-auto" :video-id="'22TbpI7osd4'"></youtube>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-container> -->
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      cards: this.$i18n.t("training.cards"),
    };
  },
};
</script>
